export { default } from "./RemoveProcessingUserAccess";



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingUser/ProcessingUserAccesses/RemoveProcessingUserAccess/index.js